import { PAYMENTS_ROUTES } from '../../constants/_routes'
import paymentsTypes from '../../constants/paymentsTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const payments_index_request = () => {
  return {
    type: paymentsTypes.index.request
  }
}

const payments_index_success = (response) => {
  return {
    type: paymentsTypes.index.success,
    payload: response.data
  }
}

const payments_index_failure = (messages) => {
  return {
    type: paymentsTypes.index.failure,
    payload: messages
  }
}

const payments_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(payments_index_request())

    // Request
    axios.get(
      PAYMENTS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( payments_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching payment."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( payments_index_failure(errors))
    })
  }

}

export {
  payments_index
}



// WEBPACK FOOTER //
// ./src/js/actions/payments/getindex.js